<template>
  <div class="promo-design-group flex flex-col gap-3">
    <v-checkbox
      v-model="actions.consent_enabled"
      trueValue="true"
      falseValue="false"
      label="Enable consent checkbox"
      hideDetails
    />
    <v-textarea
      v-model.trim="actions.consent_text"
      hideDetails
      variant="outlined"
      density="compact"
      label="Consent Checkbox Label"
      rows="3"
    ></v-textarea>
    <RfRetentionInsertLink
      v-model="actions.consent_text"
      title="Consent Checkbox label"
      textPlaceholder="Legal terms"
      urlPlaceholder="http://company.com/terms"
      deviceType="web"
      :insertColor="actions.consent_font_color"
    />
    <div class="promo-fonts-size-input">
      <v-text-field
        v-model.trim="actions.consent_font_size"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        label="Font Size"
        name="consent-font-size"
        required
        hideDetails
      ></v-text-field>
      <v-text-field
        v-model.trim="actions.consent_font_color"
        variant="outlined"
        density="compact"
        persistentPlaceholder
        label="Font Color"
        required
        name="consent-font-color"
        hideDetails
        @blur="actions.consent_font_color = extendHex(actions.consent_font_color)"
      ></v-text-field>
    </div>
    <v-checkbox
      v-model="actions.consent_prechecked"
      trueValue="true"
      falseValue="false"
      label="Consent checkbox ticked by default"
      hideDetails
    />
  </div>
</template>

<script setup>
import { extendHex } from "@/utils/colorHelpers";
import RfRetentionInsertLink from "./components/RfRetentionInsertLink.vue";

defineProps(["actions"]);
</script>
